import { TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { FormsFormStatusEnum } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

export const FormStatusTag = ({ formStatus }: { formStatus: FormsFormStatusEnum }) => {
  const tagInfo: { label: string; color: Color } = useMemo(() => {
    switch (formStatus) {
      case 'active':
        return { label: i18n.t('trainings.surveys.status.published'), color: Color.lime }
      case 'draft':
      default:
        return { label: i18n.t('trainings.surveys.status.draft'), color: Color.grey }
    }
  }, [formStatus])

  return (
    <Tag type={tagInfo.color} inline>
      {tagInfo.label}
    </Tag>
  )
}
